var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "table_svg__icon table_svg__icon-tabler table_svg__icon-tabler-table",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 16,
  height: 16,
  rx: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 10h16M10 4v16"
})));
export default SvgTable;